// extracted by mini-css-extract-plugin
export var boxItems = "_az-1";
export var boxItemsLg = "_az-2";
export var button = "_az-7";
export var buttonHoverless = "_az-9";
export var buttonLg = "_az-8";
export var filterGroupBox = "_az-0";
export var icon = "_az-3";
export var iconSecondary = "_az-6";
export var iconWrapper = "_az-4";
export var iconWrapperLg = "_az-5";
export var truncatedLabel = "_az-a";